import Button from '@components/Button';
import useProject from '@hooks/useProject';

import useSignUp from './hooks/useSignUp';
import styles from './styles.module.scss';

function SignUpButton() {
  const { signUpEnabled, signUp } = useSignUp();
  const project = useProject();
  return (
        <div className={styles.wrapper}>
            <Button fullWidth disabled={!signUpEnabled}
                    onClick={signUp}>
                {project?.features.authenticationEnabled ? '본인인증' : '가입 완료'}
            </Button>
        </div>
  );
}

export default SignUpButton;
